import { z } from 'zod';

export const CursorPaginationSchema = z.object({
  cursor: z.string().nullable(),
  hasMore: z.boolean(),
  limit: z.number().int().nullable().optional(),
  offset: z.number().int().nullable().optional(),
  totalCount: z.number().int().nullable().optional(),
});

export type CursorPagination = z.infer<typeof CursorPaginationSchema>;

export const PaginationWithOffsetSchema = z.object({
  page: z.number().int(),
  limit: z.number().int(),
  offset: z.number().int(),
  totalPages: z.number().int(),
  hasNextPage: z.boolean(),
  hasPreviousPage: z.boolean(),
});

export type PaginationWithOffset = z.infer<typeof PaginationWithOffsetSchema>;

export const PaginationOffsetSchema = PaginationWithOffsetSchema.pick({
  page: true,
  limit: true,
  offset: true,
});

export type PaginationOffset = z.infer<typeof PaginationOffsetSchema>;

export const PaginationOffsetHasMoreSchema = z.object({
  limit: z.number().int(),
  offset: z.number().int(),
  totalCount: z.number().int().nullable().optional(),
  hasMore: z.boolean(),
});

export type PaginationOffsetHasMore = z.infer<typeof PaginationOffsetHasMoreSchema>;

export const PaginationPageHasMoreSchema = z.object({
  page: z.number().int(),
  limit: z.number().int(),
  totalCount: z.number().int().nullable().optional(),
  hasMore: z.boolean(),
});

export type PaginationPageHasMore = z.infer<typeof PaginationPageHasMoreSchema>;

export const createListQuerySchema = <SortFields extends readonly [string, ...string[]]>(
  sortFields: SortFields,
  options?: {
    minLimit?: number;
    maxLimit?: number;
    defaultLimit?: number;
    defaultSortBy?: SortFields[number];
  }
) => {
  const minLimit = options?.minLimit ?? 1;
  const maxLimit = options?.maxLimit ?? 100;
  const defaultLimit = options?.defaultLimit ?? 50;
  const defaultSortBy = options?.defaultSortBy ?? sortFields[0];
  return z.object({
    page: z.coerce.number().int().min(1).default(1),
    limit: z.coerce.number().int().min(minLimit).max(maxLimit).default(defaultLimit),
    sortBy: z.enum(sortFields).default(defaultSortBy),
    sortOrder: z.enum(['asc', 'desc']).default('desc'),
  });
};
